<template>
	<v-dialog
		v-model="showDialog"
		max-width="600"
		@click:outside="closeDialog()"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white" class="color-white"> 作業者情報 </v-toolbar-title>
				<v-spacer />
				<v-btn icon dark @click="closeDialog()" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<div class="pa-2">
					<table width="100%" class="show-dialog-table">
						<tbody>
              <!-- TODO valueの仮の値が入っているので値変更 -->
							<ShowDetailRecord :columnName="'名前'" :value="'XXX XXX'" />
							<ShowDetailRecord :columnName="'所属'" :value="'(株)XXX'" />
							<ShowDetailRecord :columnName="'所属(正式名称)'" :value="'株式会社 XXX'" />
							<ShowDetailRecord :columnName="'保有資格・作業資格証'" :value="'XXXXXX\nXXXXX'" text/>
							<ShowDetailRecord :columnName="'郵便番号'" :value="'XXX-XXXX'" />
							<ShowDetailRecord :columnName="'住所'" :value="'XXXXXX'" />
							<ShowDetailRecord :columnName="'電話番号'" :value="'XXX-XXXXX-XXXX'" />
							<ShowDetailRecord :columnName="'血液型'" :value="'X'" />
							<ShowDetailRecord :columnName="'誕生日'" :value="'XXXX/XX/XX'" />
							<ShowDetailRecord :columnName="'備考'" :value="'XXXXXXX'" />
							<ShowDetailRecord :columnName="'添付資料'">
								<template v-slot:value>
									<span v-if="!files.length" class="filename">なし</span>
									<v-row
										class="mt-2"
										no-gutters
										v-for="file in files"
										:key="file.id"
										align="center"
									>
										<a class="d-block mr-2" :href="file.url" target="_blank"> {{ file.name }}</a>
									</v-row>
								</template>
							</ShowDetailRecord>
							<tr>
								<th class="bg-white font-weight-bold">緊急連絡先情報</th>
							</tr>

							<ShowDetailRecord :columnName="'連絡先'" :value="'XXX-XXXX-XXXX'" />
							<ShowDetailRecord :columnName="'相手の名前'" :value="'XXX XXX'" />
							<ShowDetailRecord :columnName="'作業者との関係'" :value="'XX'" />
						</tbody>
					</table>
				<v-row no-gutters class="mt-4" justify="end">
					<v-btn text @click="closeDialog()"> キャンセル </v-btn>
				</v-row>
			</div>
		</v-card>
	</v-dialog>
</template>
<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import common from "../../../helper/common"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"

export default {
	props: {
		dialog: {
			type: Boolean,
			default: false,
		},
		id: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	components: {
		ShowDetailRecord,
	},
	data() {
		return {
			worker: {},
			files: [{ name: "file.pdf", url: "https://www.google.com" }],
			common,
		}
	},
	methods: {
		fetchWorker() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/constructions/workers/${this.id}`
			axios
				.get(url, { headers })
				.then((res) => {
					this.worker = res.data.worker
					this.files = res.data.files
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		closeDialog() {
			this.showDialog = false
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(val) {
				this.$emit("update:dialog", val)
			},
		},
	},
	watch: {
		id: {
			handler(val, oldVal) {
				if (val == oldVal) return
				this.fetchWorker()
			},
			deep: true,
		},
	},
}
</script>
